import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=3facb6d4"
import script from "./popover.vue?vue&type=script&lang=tsx"
export * from "./popover.vue?vue&type=script&lang=tsx"
import style0 from "./popover.vue?vue&type=style&index=0&id=3facb6d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports